export default {
  promote: {
    label: '製品アセット',
    describe: 'プロモーション製品情報管理',
    table: {
      listEmpty: {
        describe:
          'まだプロモーション製品がありません。今すぐ新規作成してください！',
      },
      operation: {
        rules: '製品名は空白にできません',
        edittips: '編集',
        refresh: 'リフレッシュ',
        deletes: '削除',
        deletetips:
          'この製品は既に素材に関連付けられているため、削除できません。',
        delete: {
          label: 'このプロモーション製品を削除しますか',
          describe: '削除した後は元に戻せません。削除しますか？',
        },
      },
      ios: {
        rules: 'iOSプラットフォームの製品名を入力してください',
        package: 'iOSプラットフォームのパッケージ名を入力してください',
        description: 'iOSプラットフォームの説明を入力してください',
      },
      android: {
        rules: 'Androidプラットフォームの製品名を入力してください',
        package: 'Androidプラットフォームのパッケージ名を入力してください',
        description: 'Androidプラットフォームの説明を入力してください',
      },
      website: {
        description: '説明を入力してください',
        rules: '製品名を入力してください',
      },
      error: 'リダイレクトURLの形式が正しくありません',
      upload: {
        rules: 'アイコンファイルサイズは{fileSize}を超えてはいけません',
      },
      platforminfo: 'プラットフォーム',
      name: '製品名',
      operations: '操作',
      updatetime: '更新時間',
    },
    rules: {
      placeholder: 'URLは空白にできません',
    },
    icon: {
      rules: 'アイコンは空白にできません',
    },
    info: '関連するプロモーション製品',
    filter: {
      placeholder: '製品名またはパッケージ名を検索',
      platform: 'プラットフォーム',
    },
    edit: {
      label: 'プロモーション製品を編集',
      package: 'パッケージ名',
      url: 'URL',
      icon: 'アイコン',
    },
    wxgame: {
      title: 'WeChat MiniGame',
      appid: 'MiniGame APPID',
      name: 'MiniGame名',
      requiredTips: '内容を入力してください',
      icon: 'アイコン',
    },
  },
}
